import { useState, useEffect } from 'react';

import errorReporter from '@app/errorReporter';
import API from 'api';
import { useDebounce } from 'hooks';
import { message } from 'components';

import type { BrokerageUser } from './types';
import { QUERY_START_INDEX, QUERY_SIZE } from './constants';

const useBrokerageUsers = () => {
  const [users, setUsers] = useState<BrokerageUser[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, 500);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const data = await API.GET.orgUsers({
          from: QUERY_START_INDEX,
          size: QUERY_SIZE,
          multi: debouncedSearchValue,
        });

        setUsers(data.users);
      } catch (err) {
        message.error('Failed to load brokerage users');
        errorReporter.error(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [debouncedSearchValue]);

  return {
    isLoading,
    searchValue,
    setSearchValue,
    users,
  };
};

export default useBrokerageUsers;
